<template>
  <AutoComplete
    v-model="model"
    field="ocrcode"
    inputClass="form-control"
    :suggestions="values"
    :dropdown="false"
    placeholder="Ingrese la busqueda..."
    :class="classes"
    :disabled="disabled"
    @item-select="onChange"
    @complete="onComplete($event)"
  >
    <template #item="{ item }">
      <div>
        <span>{{ item.ocrcode }} - {{ item.ocrname }}</span>
      </div>
    </template>
  </AutoComplete>
</template>

<script>
import { ref, watch } from 'vue'
import searchNormaService from '../../../../../services/searchNormaService'

export default {
  name: 'AutocompleteNorma',
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    classes: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const values = ref([])
    const model = ref({
      ocrcode: '',
      ocrname: ''
    })
    /**/
    const onComplete = ({ query }) => {
      return searchNormaService({ value: query.trim() }).then(({ data }) => {
        values.value = data
      }).catch(err => {
        console.error(err.message)
      })
    }
    /**/
    const onChange = ({ value }) => {
      context.emit('update:modelValue', value.ocrcode)
    }
    /**/
    const setAccount = () => {
      values.value = []
      model.value = { ocrcode: '', ocrname: '' }
      if (props.modelValue) {
        searchNormaService({ value: props.modelValue }).then(({ data }) => {
          values.value = data
          model.value = data[0]
          context.emit('update:modelValue', props.modelValue)
        }).catch(err => {
          console.error(err.message)
        })
      }
    }
    /**/
    watch(() => props.modelValue, (value) => {
      setAccount()
    })

    return {
      model,
      values,
      onComplete,
      onChange
    }
  }
}
</script>

<style scoped>

</style>
